<template>
  <PageHeaderLayout>
    <div
      class="main-page-content auth-lg-page"
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <div class="page-header">
        <div>
          <div class="page-title">灵工认证</div>
          <div class="page-desc">
            按既有业务流程完成灵工认证申请，需先完成企业印章授权，再提交业务认证信息。
          </div>
        </div>
        <el-button plain @click="init">刷新页面数据</el-button>
      </div>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-card shadow="never" class="auth-card">
            <div slot="header" class="card-header">
              <span>当前状态</span>
              <el-tag :type="lgStatusTag.type" size="mini">
                {{ lgStatusTag.text }}
              </el-tag>
            </div>

            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="企业名称">
                {{ basicForm.company_name || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="印章授权状态">
                {{ sealStatusText }}
              </el-descriptions-item>
              <el-descriptions-item label="灵工认证状态">
                {{ lgStatusTag.text }}
              </el-descriptions-item>
              <el-descriptions-item label="状态说明">
                {{ statusRemark }}
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card shadow="never" class="auth-card">
            <div slot="header" class="card-header">
              <span>企业印章授权</span>
              <el-tag :type="sealStatusTag.type" size="mini">
                {{ sealStatusTag.text }}
              </el-tag>
            </div>

            <div class="seal-auth-box">
              <div class="seal-auth-text">请先完成企业印章授权（用于业务认证签署）</div>
              <el-button
                v-if="sealStatus === 1"
                type="success"
                plain
                disabled
              >
                已授权
              </el-button>
              <el-button
                v-else
                type="primary"
                :loading="sealLoading"
                @click="handleSealEntry"
              >
                {{ sealActionText }}
              </el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-card shadow="never" class="auth-card">
        <div slot="header" class="card-header">
          <span>业务信息</span>
        </div>

        <div id="pdfArea" class="business-wrapper">
          <div class="section-title">基础信息</div>
          <el-form
            ref="basicForm"
            :model="basicForm"
            :rules="basicRules"
            label-width="120px"
          >
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="企业名称" prop="company_name">
                  <el-input
                    v-model.trim="basicForm.company_name"
                    placeholder="请输入企业名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="从事行业" prop="inJob">
                  <el-select
                    v-model="basicForm.inJob"
                    placeholder="请选择从事行业"
                    style="width: 100%;"
                  >
                    <el-option label="用工企业" :value="1" />
                    <el-option label="人资公司" :value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户行" prop="account">
                  <el-input
                    v-model.trim="basicForm.account"
                    placeholder="请输入开户行"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业地址" prop="company_address">
                  <el-input
                    v-model.trim="basicForm.company_address"
                    placeholder="请输入企业地址"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务费率" prop="fee">
                  <el-input
                    v-model.trim="basicForm.fee"
                    placeholder="请输入服务费率"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结算规则" prop="setRules">
                  <el-input
                    v-model.trim="basicForm.setRules"
                    placeholder="请输入结算规则"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="section-title c-platform-title">
            *C端单人单月佣金区间占比
          </div>
          <el-form
            ref="commissionForm"
            :model="commissionForm"
            :rules="commissionRules"
            label-width="140px"
            class="commission-form"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="5千以内占比" prop="data_5k">
                  <el-input
                    v-model.trim="commissionForm.data_5k"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="5千-1万占比" prop="data_5k_1w">
                  <el-input
                    v-model.trim="commissionForm.data_5k_1w"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="1万-3万占比" prop="data_1w_3w">
                  <el-input
                    v-model.trim="commissionForm.data_1w_3w"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="3万-5万占比" prop="data_3w_5w">
                  <el-input
                    v-model.trim="commissionForm.data_3w_5w"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="5万-8万占比" prop="data_5w_8w">
                  <el-input
                    v-model.trim="commissionForm.data_5w_8w"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="8万-10万占比" prop="data_8w_10w">
                  <el-input
                    v-model.trim="commissionForm.data_8w_10w"
                    placeholder="请输入占比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="section-title">业务明细</div>
          <el-form
            ref="detailForm"
            :model="detailForm"
            :rules="detailRules"
            label-width="120px"
          >
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="外包业务" prop="outPacketWork">
                  <el-input
                    v-model.trim="detailForm.outPacketWork"
                    placeholder="请输入外包业务"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="银行账号" prop="bank_account">
                  <el-input
                    v-model.trim="detailForm.bank_account"
                    placeholder="请输入银行账号"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="自由职业者数量" prop="freeJobNum">
                  <el-input
                    v-model.trim="detailForm.freeJobNum"
                    placeholder="请输入人数"
                  >
                    <template slot="append">人</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票类型" prop="invoiceType">
                  <el-radio-group v-model="detailForm.invoiceType">
                    <el-radio :label="1">专票</el-radio>
                    <el-radio :label="2">普票</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务月体量" prop="MonthlyBusinessVol">
                  <el-input
                    v-model.trim="detailForm.MonthlyBusinessVol"
                    placeholder="请输入业务月体量"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="人员要求" prop="PersonnelRequire">
                  <el-input
                    v-model.trim="detailForm.PersonnelRequire"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入人员要求"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="服务验收标准" prop="service_standards">
                  <el-select
                    v-model="detailForm.service_standards"
                    multiple
                    collapse-tags
                    placeholder="请选择服务验收标准"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in serviceStandardOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="其他">
                  <div class="service-other">
                    <el-checkbox v-model="formState.service_other_check">
                      其他
                    </el-checkbox>
                    <el-input
                      v-model.trim="formState.service_other"
                      class="service-other-input"
                      placeholder="请输入其他说明"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票所需类目" prop="invoiceRequireType">
                  <el-select
                    v-model="detailForm.invoiceRequireType"
                    placeholder="请选择发票所需类目"
                    filterable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in invoiceTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票收件人姓名" prop="invoiceName">
                  <el-input
                    v-model.trim="detailForm.invoiceName"
                    placeholder="请输入收件人姓名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收件人手机号" prop="receiver_phone">
                  <el-input
                    v-model.trim="detailForm.receiver_phone"
                    placeholder="请输入收件人手机号"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收件地址" prop="receiver_address">
                  <el-input
                    v-model.trim="detailForm.receiver_address"
                    placeholder="请输入收件地址"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="promise-box">
            <el-checkbox
              v-model="checkFlag"
              @change="handlePromiseChange"
            >
              <span class="promise-text">
                本公司郑重承诺，上述内容均符合事实，并愿意承担由此产生的一切法律责任
              </span>
            </el-checkbox>
          </div>
        </div>

        <div class="action-wrap">
          <el-button @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            :loading="submitLoading"
            @click="handleEnsure"
          >
            确定
          </el-button>
        </div>
      </el-card>

      <el-dialog
        title="提示"
        :visible.sync="promiseDialogVisible"
        width="720px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-checkbox-group
          v-model="checkList"
          class="promise-check-group"
        >
          <el-checkbox
            :label="checkListOption1"
            class="promise-checkbox-item"
          >
            <div class="promise-checkbox-text">{{ checkListOption1 }}</div>
          </el-checkbox>
          <el-checkbox
            v-for="item in checkListOptions"
            :key="item"
            :label="item"
            class="promise-checkbox-item"
          >
            <div class="promise-checkbox-text">{{ item }}</div>
          </el-checkbox>
          <el-checkbox
            label="本公司郑重承诺，上述内容均符合事实，并愿意承担由此产生的一切法律责任"
            class="promise-checkbox-item"
          >
            <div class="promise-checkbox-text">
              本公司郑重承诺，上述内容均符合事实，并愿意承担由此产生的一切法律责任
            </div>
          </el-checkbox>
        </el-checkbox-group>
        <span slot="footer">
          <el-button @click="cancelPromiseDialog">取消</el-button>
          <el-button type="primary" @click="confirmPromiseDialog">
            确定
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="企业风控表"
        :visible.sync="riskDialogVisible"
        width="960px"
        append-to-body
        :close-on-click-modal="false"
      >
        <div id="finallyPdf" class="risk-preview">
          <div class="risk-title">灵活用工业务认证表</div>
          <div class="risk-row">
            <div class="risk-cell risk-label">企业名称</div>
            <div class="risk-cell risk-value risk-full">
              {{ lgRiskJson.company_name }}
            </div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">从事行业</div>
            <div class="risk-cell risk-value">
              {{ lgRiskJson.inJob == 1 ? "用工企业" : "人资公司" }}
            </div>
            <div class="risk-cell risk-label">开户行</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.account }}</div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">企业地址</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.company_address }}</div>
            <div class="risk-cell risk-label">服务费率</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.fee }}%</div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">结算规则</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.setRules }}</div>
            <div class="risk-cell risk-label">外包业务</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.outPacketWork }}</div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">银行账号</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.bank_account }}</div>
            <div class="risk-cell risk-label">自由职业者数量</div>
            <div class="risk-cell risk-value">
              {{ lgRiskJson.freeJobNum }}人
            </div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">发票类型</div>
            <div class="risk-cell risk-value">
              {{ lgRiskJson.invoiceType == 1 ? "专票" : "普票" }}
            </div>
            <div class="risk-cell risk-label">业务月体量</div>
            <div class="risk-cell risk-value">
              {{ lgRiskJson.MonthlyBusinessVol }}
            </div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">人员要求</div>
            <div class="risk-cell risk-value risk-full">
              {{ lgRiskJson.PersonnelRequire }}
            </div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">服务验收标准</div>
            <div class="risk-cell risk-value risk-full">
              {{ getServiceStandards(lgRiskJson.service_standards) }}
            </div>
          </div>
          <div
            v-if="formState.service_other_check"
            class="risk-row"
          >
            <div class="risk-cell risk-label">其他</div>
            <div class="risk-cell risk-value risk-full">
              {{ formState.service_other }}
            </div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">发票所需类目</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.invoiceRequireType }}</div>
            <div class="risk-cell risk-label">发票收件人姓名</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.invoiceName }}</div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">收件人手机号</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.receiver_phone }}</div>
            <div class="risk-cell risk-label">收件地址</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.receiver_address }}</div>
          </div>
          <div class="risk-tip-row">*C端单人单月佣金区间占比：</div>
          <div class="risk-row">
            <div class="risk-cell risk-label">5千以内占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_5k }}%</div>
            <div class="risk-cell risk-label">5千-1万占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_5k_1w }}%</div>
          </div>
          <div class="risk-row">
            <div class="risk-cell risk-label">1万-3万占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_1w_3w }}%</div>
            <div class="risk-cell risk-label">3万-5万占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_3w_5w }}%</div>
          </div>
          <div class="risk-row risk-row-last">
            <div class="risk-cell risk-label">5万-8万占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_5w_8w }}%</div>
            <div class="risk-cell risk-label">8万-10万占比</div>
            <div class="risk-cell risk-value">{{ lgRiskJson.data_8w_10w }}%</div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="showSignatureDialog">
            电子签章确认
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="电子签章确认"
        :visible.sync="signatureDialogVisible"
        width="520px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form :model="signatureForm" label-width="110px">
          <el-form-item label="签署电子章">
            <el-input v-model="signatureForm.seal_name" disabled />
          </el-form-item>
          <el-form-item label="签署手机号">
            <el-input v-model="signatureForm.telephone" disabled />
          </el-form-item>
          <el-form-item label="验证码">
            <el-input
              v-model.trim="signatureForm.code"
              placeholder="请输入验证码"
            >
              <el-button
                slot="append"
                :disabled="codeFlag"
                @click="sendCode"
              >
                {{ phoneCode }}
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="signatureDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="signatureLoading"
            @click="confirmSignature"
          >
            确认
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="印章选择"
        :visible.sync="sealDialogVisible"
        width="520px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form
          ref="sealForm"
          :model="sealForm"
          :rules="sealRules"
          label-width="100px"
        >
          <el-form-item label="印章" prop="sealId">
            <el-select
              v-model="sealForm.sealId"
              placeholder="请选择印章"
              filterable
              style="width: 100%;"
            >
              <el-option
                v-for="item in sealOptions"
                :key="item.sealId"
                :label="item.sealName"
                :value="item.sealId"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="sealDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="sealSubmitLoading"
            @click="confirmSealAuth"
          >
            确定
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="signingDialogVisible"
        width="360px"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="signing-tip">{{ qsTip }}</div>
      </el-dialog>
    </div>
  </PageHeaderLayout>
</template>

<script>
import axios from "axios";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";

const defaultBasicForm = () => ({
  company_name: "",
  inJob: 1,
  account: "",
  company_address: "",
  fee: "",
  setRules: "",
});

const defaultCommissionForm = () => ({
  data_5k: "",
  data_5k_1w: "",
  data_1w_3w: "",
  data_3w_5w: "",
  data_5w_8w: "",
  data_8w_10w: "",
});

const defaultDetailForm = () => ({
  outPacketWork: "",
  bank_account: "",
  freeJobNum: "",
  invoiceType: "",
  MonthlyBusinessVol: "",
  PersonnelRequire: "",
  service_standards: [],
  invoiceRequireType: "",
  invoiceName: "",
  receiver_phone: "",
  receiver_address: "",
});

export default {
  name: "AuthLg",
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      loading: false,
      sealLoading: false,
      submitLoading: false,
      signatureLoading: false,
      sealSubmitLoading: false,
      statusData: {},
      userMobile: "",
      phoneCode: "获取验证码",
      codeFlag: false,
      codeCount: 60,
      timer: null,
      timerQian: null,
      qsTip: "签署中，请稍后",
      uploadPdfurl: "",
      ossObj: {},
      ossData: {},
      sealOptions: [],
      sealRawList: [],
      invoiceTypeOptions: [],
      promiseDialogVisible: false,
      riskDialogVisible: false,
      signatureDialogVisible: false,
      sealDialogVisible: false,
      signingDialogVisible: false,
      checkFlag: false,
      checkListOption1:
        '1、不属于“六禁"行业：金融、律所、医疗、保险、影视，建筑劳务。“六不做”业务类型:拆分工资、雇员变非雇员、刻意逃避暴利税收、基金投资类、无业务场景、博彩传销。',
      checkListOptions: [
        "2、不存在过严重劳资纠纷、劳资败诉以及税务处罚。",
        "3、企业或者其法人未被列为失信被执行人。",
        "4、自由职业者和企业不存在劳动合同关系并为其缴纳社保。",
        "5、自由职业者未与我方关联企业具有劳动合同关系、或其他类似的劳动人事法律关系。",
        "6、自由职业者未担任企业或其关联企业的法定代表人、董事、监事、股东、高管。",
      ],
      checkList: [],
      formState: {
        service_other_check: false,
        service_other: "",
      },
      lgRiskJson: {},
      basicForm: defaultBasicForm(),
      commissionForm: defaultCommissionForm(),
      detailForm: defaultDetailForm(),
      signatureForm: {
        seal_name: "",
        telephone: "",
        code: "",
      },
      sealForm: {
        sealId: "",
      },
      serviceStandardOptions: [
        { label: "业务合同", value: 1 },
        { label: "现场照片", value: 2 },
        { label: "服务成果", value: 3 },
        { label: "销售数据统计表", value: 4 },
      ],
      basicRules: {
        company_name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        inJob: [{ required: true, message: "请选择从事行业", trigger: "change" }],
        account: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        company_address: [{ required: true, message: "请输入企业地址", trigger: "blur" }],
        fee: [{ required: true, message: "请输入服务费率", trigger: "blur" }],
        setRules: [{ required: true, message: "请输入结算规则", trigger: "blur" }],
      },
      commissionRules: {
        data_5k: [{ required: true, message: "请输入5千以内占比", trigger: "blur" }],
        data_5k_1w: [{ required: true, message: "请输入5千-1万占比", trigger: "blur" }],
        data_1w_3w: [{ required: true, message: "请输入1万-3万占比", trigger: "blur" }],
        data_3w_5w: [{ required: true, message: "请输入3万-5万占比", trigger: "blur" }],
        data_5w_8w: [{ required: true, message: "请输入5万-8万占比", trigger: "blur" }],
        data_8w_10w: [{ required: true, message: "请输入8万-10万占比", trigger: "blur" }],
      },
      detailRules: {
        outPacketWork: [{ required: true, message: "请输入外包业务", trigger: "blur" }],
        bank_account: [{ required: true, message: "请输入银行账号", trigger: "blur" }],
        freeJobNum: [{ required: true, message: "请输入自由职业者数量", trigger: "blur" }],
        invoiceType: [{ required: true, message: "请选择发票类型", trigger: "change" }],
        MonthlyBusinessVol: [{ required: true, message: "请输入业务月体量", trigger: "blur" }],
        PersonnelRequire: [{ required: true, message: "请输入人员要求", trigger: "blur" }],
        service_standards: [{ required: true, message: "请选择服务验收标准", trigger: "change" }],
        invoiceRequireType: [{ required: true, message: "请选择发票所需类目", trigger: "change" }],
        invoiceName: [{ required: true, message: "请输入发票收件人姓名", trigger: "blur" }],
        receiver_phone: [{ required: true, message: "请输入收件人手机号", trigger: "blur" }],
        receiver_address: [{ required: true, message: "请输入收件地址", trigger: "blur" }],
      },
      sealRules: {
        sealId: [{ required: true, message: "请选择印章", trigger: "change" }],
      },
    };
  },
  computed: {
    sealStatus() {
      return Number(this.statusData.seal_status || 0);
    },
    sealStatusText() {
      const map = {
        0: "未授权",
        1: "已授权",
        2: "授权失败",
        3: "已过期",
        5: "授权中",
      };
      return map[this.sealStatus] || "未授权";
    },
    sealActionText() {
      const map = {
        0: "去授权",
        2: "授权失败，重新授权",
        3: "已过期，重新授权",
        5: "授权中",
      };
      return map[this.sealStatus] || "去授权";
    },
    sealStatusTag() {
      if (this.sealStatus === 1) {
        return { text: "已授权", type: "success" };
      }
      if (this.sealStatus === 5) {
        return { text: "授权中", type: "warning" };
      }
      if (this.sealStatus === 2 || this.sealStatus === 3) {
        return { text: this.sealStatusText, type: "danger" };
      }
      return { text: this.sealStatusText, type: "info" };
    },
    lgStatusTag() {
      const text = this.pickValue([
        "lg_examine_auth_status_text",
        "lg_auth_status_text",
        "lg_status_text",
        "status_text",
      ]) || "未提交";
      if (/成功|完成|通过|已签署|已认证/.test(text)) {
        return { text, type: "success" };
      }
      if (/审核中|进行中|待处理|申请中|签署中/.test(text)) {
        return { text, type: "warning" };
      }
      if (/失败|驳回|拒绝|异常|超时|未通过/.test(text)) {
        return { text, type: "danger" };
      }
      return { text, type: "info" };
    },
    statusRemark() {
      return (
        this.pickValue([
          "remark",
          "message",
          "status_message",
          "status_desc",
          "lg_examine_auth_status_desc",
        ]) || "以服务端返回状态为准"
      );
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.clearCodeTimer();
    this.clearSignTimer();
  },
  methods: {
    async init() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchStatus(),
          this.fetchInvoiceTypeList(),
          this.prepareOss(),
          this.loadUserInfo(),
        ]);
      } finally {
        this.loading = false;
      }
    },
    getValueByPath(source, path) {
      return path.split(".").reduce((result, key) => {
        if (result === null || typeof result === "undefined") {
          return undefined;
        }
        return result[key];
      }, source);
    },
    pickValue(paths) {
      for (let i = 0; i < paths.length; i += 1) {
        const value = this.getValueByPath(this.statusData, paths[i]);
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
      return "";
    },
    getStoredCompanyName() {
      try {
        const nowCompany = JSON.parse(localStorage.getItem("nowCompany") || "{}");
        return nowCompany.name || "";
      } catch (error) {
        return "";
      }
    },
    async loadUserInfo() {
      let mobile =
        (this.$store.getters.userInfo && this.$store.getters.userInfo.mobile) ||
        "";
      if (!mobile) {
        try {
          const userInfo = await this.$api.getUserProfile();
          mobile = (userInfo && userInfo.mobile) || "";
        } catch (error) {
          mobile = "";
        }
      }
      this.userMobile = mobile;
      this.signatureForm.telephone = mobile;
    },
    normalizeSealList(result) {
      if (Array.isArray(result)) {
        return result;
      }
      if (Array.isArray(result && result.data)) {
        return result.data;
      }
      if (Array.isArray(result && result.list)) {
        return result.list;
      }
      if (Array.isArray(result && result.rows)) {
        return result.rows;
      }
      return [];
    },
    async fetchStatus() {
      const result = await this.$api.getAuthStatus({});
      this.statusData = result || {};

      const companyName =
        (this.statusData.lg_auth_json && this.statusData.lg_auth_json.company_name) ||
        this.pickValue(["company_name", "corp_name", "name"]) ||
        this.getStoredCompanyName();
      if (companyName) {
        this.basicForm.company_name = companyName;
      }

      this.signatureForm.seal_name =
        this.statusData.seal_name || this.signatureForm.seal_name;

      if (this.statusData.seal_id) {
        this.sealForm.sealId = this.statusData.seal_id;
      }

      if (
        Number(this.statusData.lg_examine_auth_status) === 3 &&
        this.statusData.lg_auth_json
      ) {
        this.fillFormFromRiskJson(this.statusData.lg_auth_json);
      }
    },
    fillFormFromRiskJson(data) {
      const source = data || {};
      this.basicForm = {
        ...defaultBasicForm(),
        ...this.basicForm,
        company_name: source.company_name || this.basicForm.company_name,
        inJob:
          source.inJob !== undefined && source.inJob !== null
            ? Number(source.inJob)
            : this.basicForm.inJob,
        account: source.account || "",
        company_address: source.company_address || "",
        fee: source.fee || "",
        setRules: source.setRules || "",
      };
      this.commissionForm = {
        ...defaultCommissionForm(),
        data_5k: source.data_5k || "",
        data_5k_1w: source.data_5k_1w || "",
        data_1w_3w: source.data_1w_3w || "",
        data_3w_5w: source.data_3w_5w || "",
        data_5w_8w: source.data_5w_8w || "",
        data_8w_10w: source.data_8w_10w || "",
      };
      this.detailForm = {
        ...defaultDetailForm(),
        outPacketWork: source.outPacketWork || "",
        bank_account: source.bank_account || "",
        freeJobNum: source.freeJobNum || "",
        invoiceType:
          source.invoiceType !== undefined && source.invoiceType !== null
            ? Number(source.invoiceType)
            : "",
        MonthlyBusinessVol: source.MonthlyBusinessVol || "",
        PersonnelRequire: source.PersonnelRequire || "",
        service_standards: Array.isArray(source.service_standards)
          ? source.service_standards
          : [],
        invoiceRequireType: source.invoiceRequireType || "",
        invoiceName: source.invoiceName || "",
        receiver_phone: source.receiver_phone || "",
        receiver_address: source.receiver_address || "",
      };
      this.formState.service_other_check = !!source.service_other_check;
      this.formState.service_other = source.service_other || "";
    },
    async fetchInvoiceTypeList() {
      const result = await this.$api.getInvoiceType({});
      const list = Array.isArray(result)
        ? result
        : Array.isArray(result && result.data)
        ? result.data
        : Array.isArray(result && result.list)
        ? result.list
        : [];
      this.invoiceTypeOptions = list.map((item) => ({
        label: item,
        value: item,
      }));
    },
    async prepareOss() {
      const dir = this.$config && this.$config.ossAppDir
        ? `${this.$config.ossAppDir}/ph/hr/`
        : "ph/hr/";
      const result = await this.$api.getOssSign({ dir });
      this.ossObj = result || {};
      this.ossData = {
        ossAccessKeyId: result.accessid,
        policy: result.policy,
        signature: result.signature,
        key: "",
      };
      this.refreshOssKey();
    },
    refreshOssKey() {
      const suffix = `${Date.now()}_${Math.random().toString(36).slice(2)}.pdf`;
      this.ossData.key = `${this.ossObj.dir || ""}${suffix}`;
    },
    getServiceStandards(values) {
      const list = Array.isArray(values) ? values : [];
      return this.serviceStandardOptions
        .filter((item) => list.indexOf(item.value) > -1)
        .map((item) => item.label)
        .join("、");
    },
    handlePromiseChange(value) {
      if (!value) {
        this.checkFlag = false;
        return;
      }
      this.checkFlag = false;
      this.checkList = [];
      this.promiseDialogVisible = true;
    },
    confirmPromiseDialog() {
      if (this.checkList.length !== 7) {
        this.$message.warning("请逐一选择");
        return;
      }
      this.promiseDialogVisible = false;
      this.checkFlag = true;
    },
    cancelPromiseDialog() {
      this.promiseDialogVisible = false;
      this.checkFlag = false;
    },
    handleCancel() {
      this.$router.back();
    },
    validateForm(refName) {
      return new Promise((resolve) => {
        this.$refs[refName].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async handleEnsure() {
      if (this.sealStatus !== 1) {
        this.$message.warning("请先完成企业印章授权");
        return;
      }

      this.submitLoading = true;
      try {
        const [basicValid, commissionValid, detailValid] = await Promise.all([
          this.validateForm("basicForm"),
          this.validateForm("commissionForm"),
          this.validateForm("detailForm"),
        ]);
        if (!basicValid || !commissionValid || !detailValid) {
          return;
        }

        if (!this.checkFlag) {
          this.$message.warning("请勾选郑重承诺");
          return;
        }

        this.lgRiskJson = {
          ...this.basicForm,
          ...this.commissionForm,
          ...this.detailForm,
          ...this.formState,
          checkList: this.checkList,
        };
        this.riskDialogVisible = true;
      } finally {
        this.submitLoading = false;
      }
    },
    async handleSealEntry() {
      if (this.sealStatus === 1) {
        this.$message.warning("已授权，无需额外操作");
        return;
      }
      this.sealLoading = true;
      try {
        await this.fetchSealList();
        this.sealDialogVisible = true;
      } finally {
        this.sealLoading = false;
      }
    },
    async fetchSealList() {
      const result = await this.$api.getSealList({
        page_size: 20,
        current_page: 1,
      });
      const list = this.normalizeSealList(result);
      this.sealRawList = list;
      this.sealOptions = list.map((item, index) => ({
        sealId: item.sealId || item.seal_id || item.id || index + 1,
        sealName: item.sealName || item.seal_name || item.name || `印章${index + 1}`,
        sealBizType: item.sealBizType || item.seal_biz_type || item.biz_type || "",
      }));
      if (!this.sealForm.sealId && this.sealOptions.length === 1) {
        this.sealForm.sealId = this.sealOptions[0].sealId;
      }
    },
    confirmSealAuth() {
      this.$refs.sealForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.sealSubmitLoading = true;
        try {
          const current = this.sealOptions.find(
            (item) => item.sealId === this.sealForm.sealId
          );
          const result = await this.$api.postSealAuth({
            sealId: current && current.sealId,
            sealName: current && current.sealName,
            sealBizType: current && current.sealBizType,
          });
          this.sealDialogVisible = false;
          const url =
            (result && result.authorizationSignUrl) ||
            (result && result.url) ||
            "";
          if (url) {
            window.open(url, "_blank");
          }
          await this.$alert("授权完成后，请刷新页面", "提示", {
            confirmButtonText: "刷新",
            showClose: false,
            callback: () => {
              window.location.reload();
            },
          });
        } finally {
          this.sealSubmitLoading = false;
        }
        return true;
      });
    },
    showSignatureDialog() {
      this.signatureForm.seal_name =
        this.statusData.seal_name ||
        this.signatureForm.seal_name ||
        (this.sealOptions.find((item) => item.sealId === this.sealForm.sealId) || {})
          .sealName ||
        "";
      this.signatureForm.telephone = this.userMobile;
      this.signatureDialogVisible = true;
    },
    clearCodeTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    startCodeTimer() {
      this.clearCodeTimer();
      let count = this.codeCount;
      this.codeFlag = true;
      this.phoneCode = `${count}秒重新发送`;
      this.timer = setInterval(() => {
        count -= 1;
        if (count > 0) {
          this.phoneCode = `${count}秒重新发送`;
        } else {
          this.clearCodeTimer();
          this.codeFlag = false;
          this.phoneCode = "获取验证码";
        }
      }, 1000);
    },
    async sendCode() {
      if (!this.userMobile) {
        this.$message.warning("未获取到签署手机号");
        return;
      }
      await this.$api.getCode({
        mobile: this.userMobile,
        mode: "online_open_account",
      });
      this.startCodeTimer();
      this.$message.success("验证码已发送");
    },
    async confirmSignature() {
      if (!this.signatureForm.code) {
        this.$message.warning("请输入验证码");
        return;
      }

      this.signatureLoading = true;
      try {
        await this.$api.verifySms({
          mobile: this.userMobile,
          mode: "online_open_account",
          code: this.signatureForm.code,
        });
        await this.exportPDF("finallyPdf");
      } finally {
        this.signatureLoading = false;
      }
    },
    exportPDF(domId) {
      return this.getPdf("灵工认证风控表", domId);
    },
    getPdf(title, domId) {
      return new Promise((resolve, reject) => {
        const opts = {
          scale: 2,
          dpi: window.devicePixelRatio * 4,
          useCORS: true,
          allowTaint: true,
          tainttest: true,
          logging: false,
        };
        html2Canvas(document.getElementById(domId), opts)
          .then((canvas) => {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageHeight = (contentWidth / 592.28) * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            const imgWidth = 595.28;
            const imgHeight = (592.28 / contentWidth) * contentHeight;
            const pageData = canvas.toDataURL("image/jpeg", 1.0);
            const pdf = new JsPDF("", "pt", "a4");

            if (leftHeight < pageHeight) {
              pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
            } else {
              while (leftHeight > 0) {
                pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= 841.89;
                if (leftHeight > 0) {
                  pdf.addPage();
                }
              }
            }

            const file = this.dataURLtoFile(
              pdf.output("dataurlstring"),
              `${title}.pdf`
            );
            this.uploadPDF(file).then(resolve).catch(reject);
          })
          .catch(reject);
      });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async uploadPDF(file) {
      this.refreshOssKey();
      const formData = new FormData();
      formData.append("ossAccessKeyId", this.ossData.ossAccessKeyId);
      formData.append("policy", this.ossData.policy);
      formData.append("signature", this.ossData.signature);
      formData.append("key", this.ossData.key);
      formData.append("file", file);
      const response = await axios.post(this.ossObj.host, formData);
      if (response.status !== 204) {
        throw new Error("上传失败");
      }
      this.uploadPdfurl = `${this.ossObj.host}/${this.ossData.key}`;
      await this.submitLgAuth();
    },
    clearSignTimer() {
      if (this.timerQian) {
        clearInterval(this.timerQian);
        this.timerQian = null;
      }
    },
    async submitLgAuth() {
      this.signingDialogVisible = true;
      this.qsTip = "签署中，请稍后";

      const result = await this.$api.postLgApply({
        lgRiskJson: this.lgRiskJson,
        riskUrl: this.uploadPdfurl,
        sealId: this.statusData.seal_id || this.sealForm.sealId,
        companyOpenBank: this.lgRiskJson.account,
        companyAccount: this.lgRiskJson.bank_account,
        companyAddress: this.lgRiskJson.company_address,
        companyRate: this.lgRiskJson.fee,
        receiverFullName: this.lgRiskJson.invoiceName,
        receiverMobile: this.lgRiskJson.receiver_phone,
        receiverAddress: this.lgRiskJson.receiver_address,
      });

      const fileId =
        (result && result.fileId) ||
        (result && result.id) ||
        (result && result.sign_file_id) ||
        "";

      if (!fileId) {
        this.qsTip = "提交成功，等待签署状态返回";
        return;
      }

      let countNum = 0;
      this.clearSignTimer();
      this.timerQian = setInterval(async () => {
        countNum += 1;
        const statusResult = await this.$api.getQsStatus(fileId, {});
        if (Number(statusResult.sign_status) === 2) {
          this.clearSignTimer();
          this.qsTip = "签署成功";
          await this.fetchStatus();
          setTimeout(() => {
            this.$router.back();
          }, 2000);
          return;
        }
        if (Number(statusResult.sign_status) === 3) {
          this.clearSignTimer();
          this.qsTip = `签署失败，${statusResult.sign_message || ""}`;
          return;
        }
        if (countNum === 5) {
          this.clearSignTimer();
          this.qsTip = "签署超时";
        }
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-lg-page {
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.page-desc {
  margin-top: 8px;
  color: #909399;
  line-height: 20px;
}

.auth-card {
  margin-bottom: 16px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seal-auth-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
}

.seal-auth-text {
  color: #606266;
  line-height: 22px;
  padding-right: 16px;
}

.business-wrapper {
  padding: 4px 0 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 12px 0 16px;
}

.c-platform-title {
  margin-top: 8px;
}

.commission-form {
  padding: 16px 16px 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 16px;
}

.service-other {
  display: flex;
  align-items: center;
}

.service-other-input {
  width: 320px;
  margin-left: 16px;
}

.promise-box {
  margin-top: 8px;
}

.promise-text {
  color: #409eff;
}

.action-wrap {
  margin-top: 8px;
  text-align: center;
}

.promise-check-group {
  display: flex;
  flex-direction: column;
}

.promise-checkbox-item {
  margin-bottom: 12px;
  line-height: 22px;
}

.promise-checkbox-text {
  white-space: normal;
  word-break: break-all;
}

.risk-preview {
  padding: 16px;
  color: #121212;
}

.risk-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.risk-row {
  display: flex;
  border-left: 1px solid #121212;
  border-right: 1px solid #121212;
  border-top: 1px solid #121212;
}

.risk-row-last {
  border-bottom: 1px solid #121212;
}

.risk-tip-row {
  border-left: 1px solid #121212;
  border-right: 1px solid #121212;
  border-top: 1px solid #121212;
  padding: 20px 16px;
  font-weight: 600;
}

.risk-cell {
  min-height: 58px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 14px;
  line-height: 22px;
}

.risk-label {
  width: 140px;
  justify-content: center;
  font-weight: 600;
  border-right: 1px solid #121212;
}

.risk-value {
  flex: 1;
}

.risk-full {
  flex: 1 1 0;
}

.signing-tip {
  margin-top: 12px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
</style>
